<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <div class="row m-4" >
          <div class="col-md-1">
            <h4>Баннеры</h4>
          </div>
          <div class="col-md-2">
            <el-button type="success" @click="goToPage('banner/create')">Добавить новый баннер</el-button>
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск" >
          <el-row>
            <el-col :span="10">
              <el-form-item label="Поиск по названию">
                <el-col :span="14">
                  <el-input v-model="query.q" @change="setQueryReset()"></el-input>
                </el-col>

              </el-form-item>
            </el-col>
              <el-col :span="8">
                  <el-form-item label="Сортировка">
                      <el-select v-model="query.sort" :width="300" @change="setQuery()">
                        <el-option
                          v-for="(it, index) in sort"
                          :key="index"
                          :value="it.field"
                          :label="it.title"
                        />
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>


        </el-form>
        <el-table
            :data="banners"
            style="width: 100%"
            empty-text="Нет банннеров">
          <el-table-column
              prop="id"
              label="Id"
              width="50"
          >
          </el-table-column>
          <!-- <el-table-column
              prop="slug"
              label="Slug"
          >
          </el-table-column> -->
          <el-table-column
              prop="title"
              label="Название"
              width="400"
          >
          </el-table-column>

          <el-table-column
              prop="btn_text"
              label="Текст кнопки"
              width="200"
          >
          </el-table-column>
          <el-table-column
              prop="link"
              label="Ссылка"
          >

          </el-table-column>
            <el-table-column
                    prop="sort"
                    label="Сортировка"
            >
            </el-table-column>

            <el-table-column
                    label="Активность"
            >
                <template slot-scope="scope">
                    <p v-if="!banners[scope.$index].activity">Нет</p>
                    <p v-if="banners[scope.$index].activity">Да</p>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="Действия"
                    width="400">
                <template slot-scope="scope">
                    <el-button v-if="banners[scope.$index].activity"
                               size="mini"
                               type="primary"
                               plain
                               @click="hideRow(scope.$index)">Скрыть</el-button>
                    <el-button v-if="!banners[scope.$index].activity"
                               size="mini"
                               type="primary"
                               plain
                               @click="restoreRow(scope.$index)">Восстановить</el-button>
                    <el-button
                               size="mini"
                               @click="updateRow(scope.$index)">Изменить</el-button>
                    <el-button
                               size="mini"
                               type="danger"
                               @click.native.prevent="deleteRow(scope.$index)">Удалить</el-button>
                </template>
            </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="paginator.total"
            :current-page.sync="current"
            @current-change="getPage(current)"
            :hide-on-single-page="true"
            :page-size="paginator.per_page"
            :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import sortConfig from '../../composable/config/banners-sort.config'
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
  name: "Banners",

  data: function (){
    return{
      sort: sortConfig,
      status:0,
      banners:[],
      paginator:[],
      current:0,
      query:{
          q: undefined,
          sort: sortConfig[0].field,
          page: 1,
      }
    }
  },
  mounted() {    
    this.initParams(this.$route.query);
    this.getBanners(this.getQuery(this.$route.query));
  },
  computed: {
    activeSort() {
      const result = this.sort.find((e) => e.field === this.query.sort)
      return result ? result.options  : undefined
    },
  },
  watch:{
    '$route.query'(v){   
      const query = this.getQuery(v)   
      if (query){              
        this.getBanners(query)
      }
    }
  },
  methods:{        
    getBanners: function (query){ 
      this.$store.commit(SETPRELOADER_STATE, true)    
      axios.get(`/banner${query}`).then((response)=>
          {
            this.banners = response.data.data;
            this.paginator = response.data.meta;
            this.current = response.data.meta.current_page;
          }
      ).catch((errors)=>{
        if(errors.response.status === 401){
          this.$router.push('/login');
        }
      })
      .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },

    getPage: function(pageNum){
      if(pageNum!==null){
        this.query.page = pageNum
        this.setQuery();  
      }
    },
    goToPage: function (path){
      this.$router.push(path);
    },
    hideRow: function (index) {
        let id = this.banners[index].id;

        axios.post('/banner/'+id+'/hide').then((response)=>{
            this.status = response.status;
            this.getBanners();
            this.$notify.success('Баннер скрыт')
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });

    },
    restoreRow: function (index) {
        let id = this.banners[index].id;

        axios.post('/banner/'+id+'/restore').then((response)=>{
            this.status = response.status;
            this.$notify.success('Баннер восстановлен')
            this.getBanners();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });

    },
    deleteRow: function (index) {
      let id = this.banners[index].id;
       const title = this.banners[index].title

      axios.delete('/banner/'+id).then((response)=>{
        this.status = response.status;
        this.banners.splice(index, 1);
        this.$notify.success({
          title: 'Баннер удален',
          message: 'Название: ' + title
        })
      }).catch((errors)=>{
        if(errors.response.status === 401){
          this.$router.push('/login');
        }
        this.$notify.error('Не предвиденная ошибка')
      });

    },
    updateRow: function (index) {
      let id = this.banners[index].id;
      this.$router.push('/banner/'+id+'/update');
    },
    setQueryReset(){
      this.query.page = 1
      this.setQuery()
    },
    setQuery(){
      const result = {};
      let isChange = false;
      
      if (this.activeSort) {
        isChange = true;
        result['sort']= {
            by: this.activeSort.by,
            order: this.activeSort.order
        }     
      }
      if (this.query.q) {
        isChange = true;
        result['q']=this.query.q
      }
      if(this.query.page){
        isChange = true
        result['page']=this.query.page
      }

      if (isChange) {
        const q = this.getQuery(result)
        this.$router.push({
          path: 'banners' + q,
        })
      }
    }, 
    getQuery(query) {
      if (Object.keys(query).length > 0){        
        const qs = require('qs');
        return `?${qs.stringify(query)}`
      }
      return ''
    },
    initParams(query){
      if (!query){
        return
      }

      const qs = require('qs');
      const parseQuery= qs.parse(query);

      if (parseQuery.sort?.by && parseQuery.sort?.order) {
        this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
      }
      if (parseQuery.q){
        this.query.q = parseQuery.q
      }
      if(parseQuery.page){
        this.query.page= parseQuery.page
      }
    }
  }
}
</script>

<style scoped>
  .pagination{
    display: -ms-flexbox;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
  }
</style>